import React, { memo } from 'react';
import { zipCodeRegex } from 'utils/helpers';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Col, CountrySelect, Form, FormModal, Input, Row, Select, Tooltip } from 'components';
import { useAddressUpdate } from './useAddressUpdate';
import { ValidationErrors } from 'constants/validations';

const { Item } = Form;

export interface ICustomAddressAddEdit {
  modalState: boolean;
  onModalStateChange: () => void;
  dataToEdit: Record<string, any> | undefined;
  onSuccess: () => void;
}

export const CustomAddressAddEdit = memo<ICustomAddressAddEdit>((props) => {
  const { onModalStateChange, modalState, dataToEdit, onSuccess } = props;
  const { onFinish, isLoading, form, states, handleCountryChange, onCancel } = useAddressUpdate({
    onModalStateChange,
    modalState,
    dataToEdit,
    onSuccess,
  });
  return (
    <FormModal
      form={form}
      title={`${dataToEdit ? 'Update' : 'Add'} Custom Address`}
      okText={`${dataToEdit ? 'Save' : 'Add'}`}
      open={modalState}
      isLoading={isLoading}
      onSubmit={onFinish}
      onCancel={onCancel}
      autoComplete="off"
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Item
            name={'countryId'}
            label={'Country*'}
            rules={[
              {
                required: true,
                message: ValidationErrors.required('Country'),
              },
            ]}
          >
            <CountrySelect size={'large'} onSelect={handleCountryChange} />
          </Item>
        </Col>
        {!!states.length && (
          <Col span={12}>
            <Item
              name={'state'}
              label={'State*'}
              rules={[
                {
                  required: true,
                  message: ValidationErrors.required('State'),
                },
              ]}
            >
              <Select
                options={states}
                size={'large'}
                showSearch
                filterOption={(input, option: any) =>
                  option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false
                }
              />
            </Item>
          </Col>
        )}
        <Col span={12}>
          <Item
            name={'city'}
            label={'City*'}
            rules={[
              {
                required: true,
                message: ValidationErrors.required('City'),
              },
            ]}
          >
            <Input size={'large'} />
          </Item>
        </Col>
        <Col span={12}>
          <Item
            name={'streetAddress'}
            label={'Street Address*'}
            rules={[
              {
                required: true,
                message: ValidationErrors.required('Street Address'),
              },
            ]}
          >
            <Input size={'large'} />
          </Item>
        </Col>
        <Col span={12}>
          <Item
            name={'zip'}
            label={'Zip Code*'}
            rules={[
              {
                required: true,
                message: ValidationErrors.required('Zip Code'),
              },
              {
                pattern: zipCodeRegex,
                message: 'Enter a valid ZIP/Postal Code',
              },
            ]}
          >
            <Input
              suffix={
                <Tooltip title="Standard formats: 12345, 12345-6789, A1A 1A1, SW1A 1AA, 1234 AB, C1000W1A, 01000-000, 123-4567, 100000.">
                  <InfoCircleOutlined style={{ color: '#05796B' }} />
                </Tooltip>
              }
              size={'large'}
            />
          </Item>
        </Col>
      </Row>
    </FormModal>
  );
});
